import DevelopmentClientEditContainer from './containers/DevelopmentClientEditContainer'

export default DevelopmentClientEditContainer
